(function (global) {
  'use strict';

  var STATS_ACTION_ENDPOINT = '/api/v3/stats/action';

  function getStoredDeviceUuid() {
    try {
      var directUuid = localStorage.getItem('device_uuid') || localStorage.getItem('deviceUUID');
      if (directUuid) {
        return directUuid;
      }

      var modelDataRaw = localStorage.getItem('modelData');
      if (!modelDataRaw) {
        return null;
      }

      var modelData = JSON.parse(modelDataRaw);
      return modelData.deviceUUID || modelData.device_uuid || modelData.deviceId || null;
    } catch (error) {
      console.error('[stats-action] failed to read device_uuid:', error);
      return null;
    }
  }

  function sendStatsAction(deviceUuid, eventName) {
    if (!eventName) {
      console.error('[stats-action] event is required');
      return;
    }

    var payload = {
      event: eventName
    };

    if (deviceUuid) {
      payload.device_uuid = deviceUuid;
    }

    try {
      fetch(STATS_ACTION_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'include'
      })
        .then(function (response) {
          if (!response.ok) {
            console.error('[stats-action] request failed with status:', response.status);
          }
        })
        .catch(function (error) {
          console.error('[stats-action] request failed:', error);
        });
    } catch (error) {
      console.error('[stats-action] request init failed:', error);
    }
  }

  function trackCurrentPage(deviceUuid) {
    var pathname = (global.location && global.location.pathname) || '/';
    var resolvedDeviceUuid = deviceUuid || getStoredDeviceUuid();
    sendStatsAction(resolvedDeviceUuid, pathname);
  }

  global.sendStatsAction = sendStatsAction;
  global.trackCurrentPageAction = trackCurrentPage;

  trackCurrentPage();
})(window);
